import React from "react";

const QrCode = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-qr-code"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-qr-code"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path d="M7,11h-3C1.794,11,0,9.206,0,7v-3C0,1.794,1.794,0,4,0h3c2.206,0,4,1.794,4,4v3c0,2.206-1.794,4-4,4ZM4,3c-.551,0-1,.449-1,1v3c0,.551,.449,1,1,1h3c.551,0,1-.449,1-1v-3c0-.551-.449-1-1-1h-3Zm16,8h-3c-2.206,0-4-1.794-4-4v-3c0-2.206,1.794-4,4-4h3c2.206,0,4,1.794,4,4v3c0,2.206-1.794,4-4,4Zm-3-8c-.552,0-1,.449-1,1v3c0,.551,.448,1,1,1h3c.552,0,1-.449,1-1v-3c0-.551-.448-1-1-1h-3ZM7,24h-3C1.794,24,0,22.206,0,20v-3C0,14.794,1.794,13,4,13h3c2.206,0,4,1.794,4,4v3c0,2.206-1.794,4-4,4Zm-3-8c-.551,0-1,.449-1,1v3c0,.551,.449,1,1,1h3c.551,0,1-.449,1-1v-3c0-.551-.449-1-1-1h-3Zm13-.5v-1c0-.828-.672-1.5-1.5-1.5h-1c-.828,0-1.5,.672-1.5,1.5v1c0,.828,.672,1.5,1.5,1.5h1c.828,0,1.5-.672,1.5-1.5Zm3,3h0c0-.828-.672-1.5-1.5-1.5h0c-.828,0-1.5,.672-1.5,1.5h0c0,.828,.672,1.5,1.5,1.5h0c.828,0,1.5-.672,1.5-1.5Zm-3,4v-1c0-.828-.672-1.5-1.5-1.5h-1c-.828,0-1.5,.672-1.5,1.5v1c0,.828,.672,1.5,1.5,1.5h1c.828,0,1.5-.672,1.5-1.5Zm7-7v-1c0-.828-.672-1.5-1.5-1.5h-1c-.828,0-1.5,.672-1.5,1.5v1c0,.828,.672,1.5,1.5,1.5h1c.828,0,1.5-.672,1.5-1.5Z" />
    </svg>
  );
};

export default QrCode;
